import classNames from 'classnames';
import { CarouselPage } from './CarouselPage';
import { useEffect, useRef, useState } from 'react';

type Props = {
    pages: React.ReactNode[];
    className?: string;
    style?: React.CSSProperties;
    currentPage?: number;
};

export function Carousel({
    pages,
    className,
    currentPage = 0,
    ...props
}: Props) {
    const containerRef = useRef<HTMLDivElement>(null);
    const [activePage, setActivePage] = useState(currentPage);

    useEffect(() => {
        const el = containerRef.current;
        if (el) {
            el.scrollLeft = el.clientWidth * currentPage;
        }
    }, [currentPage]);

    return (
        <div className={className} {...props}>
            <div
                ref={containerRef}
                className="hide-scrollbar flex snap-x snap-mandatory overflow-x-scroll whitespace-nowrap"
                onScroll={(e: React.SyntheticEvent<HTMLDivElement>) => {
                    const element = e.currentTarget;
                    const width = element.clientWidth;
                    const scrollOffset = element.scrollLeft;
                    const pageNumber = scrollOffset / width;

                    const nearest = Math.round(pageNumber);
                    const threshold = 0.2;

                    if (
                        (nearest > pageNumber &&
                            nearest < pageNumber + threshold) ||
                        (nearest < pageNumber &&
                            nearest > pageNumber - threshold)
                    ) {
                        setActivePage(nearest);
                    }
                }}
            >
                {pages.map((x, idx) => (
                    <CarouselPage key={idx} className="mr-20">
                        {x}
                    </CarouselPage>
                ))}
            </div>
            <div className="text-center">
                {pages.map((_, idx) => (
                    <span
                        key={idx}
                        className={classNames(
                            'inline-block h-[12px] w-[12px] rounded-lg',
                            {
                                'bg-dark-red': activePage === idx,
                                'bg-dark-red-34p': activePage !== idx,
                                'ml-[12px]': idx !== 0,
                            },
                        )}
                    />
                ))}
            </div>
        </div>
    );
}
